export function fireTrackingUrl(url: string): void {
  if (typeof fetch === "function") {
    try {
      void fetch(url, {
        method: "GET",
        keepalive: true,
        mode: "no-cors",
      });
      return;
    } catch {
      // Continue to image fallback.
    }
  }

  if (typeof Image !== "undefined") {
    new Image().src = url;
  }
}
